// extracted by mini-css-extract-plugin
export var modal = "_k2-0";